export default __webpack_public_path__ + "static/media/insertImage.ccb4cc76.svg";